import authRouteConfig from "./authRouteConfig.json";

type AuthRedirectOptions = {
  hasRefreshToken: boolean;
  pathname: string;
  search?: string;
};

export const REFRESH_TOKEN_COOKIE_NAME = authRouteConfig.refreshTokenCookieName;

function getIsExactOrChildPath(pathname: string, prefix: string) {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function getIsPublicPath(pathname: string) {
  return authRouteConfig.publicRoutePrefixes.some((prefix) =>
    getIsExactOrChildPath(pathname, prefix),
  );
}

export function getIsProtectedPath(pathname: string) {
  return !getIsPublicPath(pathname);
}

export function getAuthenticatedRedirectPath(pathname: string) {
  return authRouteConfig.authenticatedRedirects.find(({ source }) =>
    getIsExactOrChildPath(pathname, source),
  )?.destination;
}

function getUnauthenticatedRedirectPath(pathname: string, search?: string) {
  const params = new URLSearchParams({
    next: `${pathname}${search || ""}`,
  });

  return `/login?${params.toString()}`;
}

export function getAuthRedirectPath({
  hasRefreshToken,
  pathname,
  search,
}: AuthRedirectOptions) {
  if (getIsPublicPath(pathname) || hasRefreshToken) return;
  return getUnauthenticatedRedirectPath(pathname, search);
}
